/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { StreemApiCompanyApiKeyFromJSON, StreemApiCompanyApiKeyToJSON, } from './';
export function StreemApiListCompanyApiKeysResponseFromJSON(json) {
    return StreemApiListCompanyApiKeysResponseFromJSONTyped(json, false);
}
export function StreemApiListCompanyApiKeysResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'apiKeys': !exists(json, 'api_keys') ? undefined : (json['api_keys'].map(StreemApiCompanyApiKeyFromJSON)),
        'nextPageToken': !exists(json, 'next_page_token') ? undefined : json['next_page_token'],
        'totalSize': !exists(json, 'total_size') ? undefined : json['total_size'],
    };
}
export function StreemApiListCompanyApiKeysResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'api_keys': value.apiKeys === undefined ? undefined : (value.apiKeys.map(StreemApiCompanyApiKeyToJSON)),
        'next_page_token': value.nextPageToken,
        'total_size': value.totalSize,
    };
}
//# sourceMappingURL=StreemApiListCompanyApiKeysResponse.js.map